<template>
  <DragDialog
    :title="`解析失败列表(${fileList.length})`"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog"
  >
    <div class="common-table-box">
      <div v-if="isLoading" class="loading-box">
        <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
      </div>
      <el-table class="publish-table publish-small-table" highlight-selection-row v-else height="100%" :data="fileList">
        <el-table-column label="序号" type="index" width="75" />
        <el-table-column label="文件名称" width="270">
          <template v-slot="{ row }">
            <span class="text-overflow" :title="row.fileName">
              {{ row.fileName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="文件类型" prop="suffix" />
        <el-table-column label="文件大小" width="120">
          <template v-slot="{ row }">
            <span>
              {{
                `${formatFileSize(row.size).fileSize}
                ${formatFileSize(row.size).unit}`
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="失败原因" width="180">
          <template v-slot="{ row }">
            {{ checkResultMap[row.checkResult] }}
          </template>
        </el-table-column>
        <el-table-column label="上传时间" width="180">
          <template v-slot="{ row }">
            {{
              row.lastModificationTime
                ? formatTime(row.lastModificationTime)
                : formatTime(row.creationTime)
            }}
          </template>
        </el-table-column>
        <el-table-column label="上传至">
          <template v-slot="{ row }">
            <span class="text-overflow" :title="row.uploadPathName">
              {{ row.uploadPathName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button
                type="text"
                size="small"
                @click="reCheck(row)"
                v-if="row.uploadStatus === 5"
              >
                重新解析
              </el-button>
              <el-button
                key="checking"
                type="text"
                size="small"
                v-if="row.uploadStatus === 8"
                :disabled="row.uploadStatus === 8"
              >
                解析中
              </el-button>
              <el-button type="text" size="small" @click="downloadFile(row)">
                下载
              </el-button>
              <el-button type="text" size="small" @click="deleteFileById(row)">
                移除
              </el-button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import Spin from "@/components/Spin.vue";

import { formatFileSize, formatTime, getTokenId } from "@/utils/generalMethods";

import {
  getFileList,
  deleteFileService,
  reCheckFileService,
} from "@/service/interface";

export default {
  data() {
    return {
      isLoading: false,
      fileList: [],
      timer: null,
      checkResultMap: {
        RvtGet3DError: "三维视图读取失败",
        DemConstructError: "文件格式错误",
        DemUnZipError: "解压失败",
        OsgbConstructError: "文件格式错误",
        OsgbUnZipError: "解压失败",
        CadError: "解析失败",
        VectorUploadError: "矢量解析失败",
      },
    };
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
  },
  components: {
    DragDialog,
    Spin,
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initFileList();
      } else {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
  methods: {
    initFileList() {
      this.isLoading = true;
      this.queryFileList().then(() => {
        this.isLoading = false;
      });
    },
    reCheck(fileInfo) {
      let fileDataId = fileInfo.id;
      reCheckFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.refreshFileList();
          if (!this.timer) {
            this.timer = setInterval(this.refreshFileList, 1000);
          }
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    downloadFile(fileInfo) {
      this.$message({
        message: "开始下载文件，请勿重复操作......",
        type: "info",
        duration: 3 * 1000,
      });

      let url = "";
      let tokenId = getTokenId();
      let fileDataId = fileInfo.id;
      if (window.downloadUrl.includes("http")) {
        url = `${window.downloadUrl}/${fileDataId}?token=${tokenId}`;
      } else {
        url = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`;
      }

      let iframe = document.createElement("iframe");
      iframe.id = "hiddenDownloader";
      iframe.style.display = "none";
      document.body.appendChild(iframe);

      iframe.src = url;
    },
    deleteFileById(fileInfo) {
      let fileDataId = fileInfo.id;
      deleteFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.queryFileList();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    refreshFileList() {
      this.queryFileList().then(() => {
        const uploadStatus = [8];
        let reCheckFiles = this.fileList.filter((el) =>
          uploadStatus.includes(el.uploadStatus)
        );
        if (!reCheckFiles.length) {
          this.destroyTimer();
        }
      });
    },
    queryFileList() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: "",
          status: [5, 7, 8],
        };
        getFileList(params).then((response) => {
          if (response.isSuccess) {
            let result = response.data;
            let fileList = result.items;

            // 从上传列表中移除构件库上传的文件
            // prettier-ignore
            const schemeTypes = ["CLPrivateDoc", "CLPublicDoc", "Rvtuv","Capability", 'SceneAnnotationAttachment',"SceneAnchorPointAttachment"];
            fileList = fileList.filter(
              (el) => !schemeTypes.includes(el.scheme)
            );

            fileList.forEach((item) => {
              let bussinessInfo = item.fileBusinessInfo;
              let { projName, treePathName } = bussinessInfo;
              item.uploadPathName = `${projName}/${treePathName}`;
            });
            fileList = fileList.filter((el) => el.isAuthorized);

            this.fileList = fileList;
            resolve();
          }
        });
      });
    },
    destroyTimer() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    formatFileSize,
    formatTime,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.common-table-box {
  height: 500px;

  .common-button-box {
    display: flex;
  }
}
</style>